export const accessToken =
  "pk.eyJ1Ijoic2ViYXN0aWFhbmphbnNlbiIsImEiOiJjamdkZXVudXEwcDc2MzNueDlrYndnaWR0In0.Ez4nc3Cw42ZThCFhum-zxg";



// WEBPACK FOOTER //
// ./src/accessToken.js